var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',[_c('div',{staticClass:"align",attrs:{"id":"headBar"}},[_c('div',{attrs:{"id":"mainLogo"}},[_c('IconBase',{attrs:{"viewBox":'0 0 184 35'}},[_c('logo_FINMOLL')],1)],1),_c('div',{attrs:{"id":"midHead"}},[_c('email'),_c('phone')],1),_c('button',{staticStyle:{"display":"none"}},[_vm._v("ЗАКАЗАТЬ ЗВОНОК")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }